import {FC, useState, createContext, useContext} from 'react'
import {
    QueryState,
    QueryRequestContextProps,
    initialQueryRequest,
    WithChildren,
} from '../../../../../_metronic/helpers'

const DLMApplicationQueryRequestContext = createContext<QueryRequestContextProps>(initialQueryRequest)

const DLMApplicationQueryRequestProvider: FC<WithChildren> = ({children}) => {
    const [state, setState] = useState<QueryState>(initialQueryRequest.state)

    const updateState = (updates: Partial<QueryState>) => {
        const updatedState = {...state, ...updates} as QueryState
        setState(updatedState)
    } 

    return (
    <DLMApplicationQueryRequestContext.Provider value={{state, updateState}}>
        {children}
    </DLMApplicationQueryRequestContext.Provider>
    )
}

const useDLMApplicationQueryRequest = () => useContext(DLMApplicationQueryRequestContext)
export {DLMApplicationQueryRequestProvider, useDLMApplicationQueryRequest}
